(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory4LangService", ['$ihttp', function ($ihttp) {
        let service = {
            listTextileModelCategory4Languages: function (parms) {
                return $ihttp.post({
                    method: 2683,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2684,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
